import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Button } from '../ui/Button'
import styles from '@/styles/components/governance/GovernanceCard.module.css'

export interface GovernanceCardProps {
  /** Card heading */
  title: string
  /** Short description under the title */
  description: string
  /** Leading icon (e.g. Lucide icon with size/color classes) */
  icon: ReactNode
  /** Label for the primary action (primary CTA) */
  buttonLabel: string
  /** In-app route opened on button click */
  to: string
  /** Extra classes on the outer card shell */
  className?: string
}

/**
 * Overview-style governance tile: icon + title + description + primary CTA.
 * Used on the governance overview grid (4 columns on large screens).
 */
export function GovernanceCard({
  title,
  description,
  icon,
  buttonLabel,
  to,
  className = '',
}: GovernanceCardProps) {
  const navigate = useNavigate()

  return (
    <div
      className={`governance-card ${styles.root} ${className}`.trim()}
    >
      <div className={styles.header}>
        {icon}
        <h2 className={styles.title}>{title}</h2>
      </div>
      <p className={styles.description}>{description}</p>
      <Button
        type="button"
        size="small"
        color="primary"
        fullWidth
        icon={<ArrowRight className="h-3.5 w-3.5" aria-hidden />}
        iconPosition="end"
        onClick={() => navigate(to)}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}

export default GovernanceCard
